interface StarButtonProps {
    isFavorite: boolean;
    onClick: () => void;
    size?: 'sm' | 'md';
    noPadding?: boolean;
}

export default function StarButton({ isFavorite, onClick, size = 'md', noPadding = false }: StarButtonProps) {
    return (
        <button 
            onClick={onClick}
            className={`hover:bg-gray-100 rounded ${size === 'sm' ? 'scale-75' : ''} ${noPadding ? '' : 'p-1'}`}
        >
            <svg 
                viewBox="0 0 24 24" 
                className={`w-5 h-5 ${isFavorite ? 'text-yellow-400' : 'text-gray-400'} hover:text-yellow-400`}
                xmlns="http://www.w3.org/2000/svg"
            >
                <path 
                    d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" 
                    fill={isFavorite ? 'currentColor' : 'none'} 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
} 